import React from 'react';
import cx from 'classnames';

import { getOutcomeParam, isSuspended } from '@atlas/core';
import { useDropdown } from '@atlas/ui';

import SimpleOutcomeComponent from './SimpleOutcomeComponent';

const defaultMarketSortingFunction = (a, b) => {
  const paramA = Number.parseFloat(getOutcomeParam(a));
  const paramB = Number.parseFloat(getOutcomeParam(b));

  return paramA * 100 - paramB * 100;
};

const SimpleParametricMarketTypeDropdown = props => {
  const { containerRef, event, marketType, markets, suspended } = props;
  const [isExpanded, setExpanded] = React.useState(false);

  const toggleExpandHandler = React.useCallback(
    e => {
      e.preventDefault();

      setExpanded(!isExpanded);
    },
    [isExpanded],
  );

  useDropdown(containerRef, () => setExpanded(false));

  const sortedMarkets = React.useMemo(() => markets.sort(defaultMarketSortingFunction), [markets]);

  const isMoreMarketsAvailable = sortedMarkets.length > 1;

  return (
    <>
      {isExpanded && isMoreMarketsAvailable && (
        <div className="market-expanded-dropdown">
          <div className="market-expanded-dropdown-container">
            {sortedMarkets.map(market => {
              const marketSuspended = suspended || isSuspended(market);

              return (
                <SimpleOutcomeComponent
                  event={event}
                  key={market.id}
                  market={market}
                  marketType={marketType}
                  suspended={marketSuspended}
                />
              );
            })}
          </div>
        </div>
      )}

      {isMoreMarketsAvailable && (
        <div
          className={cx('market-expanded-button', { expanded: isExpanded })}
          onClick={toggleExpandHandler}
          role="button"
        />
      )}
    </>
  );
};

export default SimpleParametricMarketTypeDropdown;
